export const CONTACT_HOURS = (
  <>
    Mon to Fri - 8am to 8pm CT
    <br />
    Sat to Sun - 9am to 6pm CT
  </>
);

export const VELO_DESCRIPTION = (
  <>
    Your <b>24/7</b> Business Assistant
  </>
);
